import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'url'
})
export class UrlPipe implements PipeTransform {

  /* This pipe will take a value and ensure it has http:// at the beginning */
  transform(value: string, ...args: any[]): any {
    if (value.length <= 6) return;
    if (value.startsWith('http://')) {
      //Do nothing, it's prepended
    } else {
      //Add it ourselves
      value = "http://" + value;
    }
    
    return value;
  }

}
